import React, { CSSProperties, FC } from "react";

import { drawnSize, FRAME, Placement, Rect } from "./logo.utils";

/** Checkered background = transparent parts of the logo. */
export const CHECKERBOARD: CSSProperties = {
  backgroundColor: "#FFFFFF",
  backgroundImage:
    "linear-gradient(45deg,#EEF0F4 25%,transparent 25%),linear-gradient(-45deg,#EEF0F4 25%,transparent 25%),linear-gradient(45deg,transparent 75%,#EEF0F4 75%),linear-gradient(-45deg,transparent 75%,#EEF0F4 75%)",
  backgroundSize: "16px 16px",
  backgroundPosition: "0 0,0 8px,8px -8px,-8px 0",
};

const pct = (value: number) => `${value * 100}%`;

/** The (trimmed) picture placed in a 3:1 box exactly like the saved PNG:
 * everything is in percentages of the box, so it works at any size. */
export const FramedPicture: FC<{
  url: string;
  width: number;
  height: number;
  crop: Rect;
  placement: Placement;
}> = ({ url, width, height, crop, placement }) => {
  const size = drawnSize(crop, placement.zoom);
  return (
    <div
      className={"pointer-events-none absolute overflow-hidden"}
      style={{
        left: pct(placement.x / FRAME.width),
        top: pct(placement.y / FRAME.height),
        width: pct(size.width / FRAME.width),
        height: pct(size.height / FRAME.height),
      }}>
      <img
        src={url}
        alt={""}
        draggable={false}
        className={"absolute max-h-none max-w-none select-none"}
        style={{
          left: pct(-crop.x / crop.width),
          top: pct(-crop.y / crop.height),
          width: pct(width / crop.width),
          height: pct(height / crop.height),
        }}
      />
    </div>
  );
};
